const ko = {
    num: '숫자',
    creator: "작성자",
    createdAt: "작성 시간",
    invStatus: '재고 상태',
    opt: '작업',
    startInv: '재고를 조사하고 싶습니다',
    validaFail: '검증 실패',
    invalidFormat: '제품명과 수량 형식은 정확해야 합니다',
    operator: '운영자',
    operaTime: '작업 시간',
    invRequest: '재고 신청서',
    basicInfo: '기본 정보',
    warehouseItems: '창고 품목',
    itemList: '제품 목록',
    item: '제품',
    quantity: '수량',
    enterQuantity: '입력할 수량을 입력해주세요',
    cancel: '취소',
    next: '다음 단계',
    addFailed: '추가 실패',
    diffTip: '창고 바코드와 재고 바코드를 비교하면 다음과 같은 차이점이 있습니다.',
    oneClickInOut: '한번 클릭으로 나가기/들어가기',
    oneClickIn: '한 번의 클릭으로 도서관에 접속',
    oneClickOut: '한번 클릭으로 배달',
    doError: '차이점 생성에 실패했습니다, {{err}}',
    operationTips: '현재 조직은 재고를 조사 중이므로 운영할 수 없습니다. ',
    createDiff: '차이 생성',
    endCounting: '카운팅 종료',
    getDiffDataTip: '차이 데이터를 가져오는 중입니다. 잠시만 기다려 주세요...',
    countingDataInventorySuccs: '재고 데이터 성공적으로 전송/수신',
    countingFinish: '카운팅 완료',
    countingNoData: '카운팅 데이터가 존재하지 않습니다',
    countingCancelDiff: '현재 차액 데이터가 생성되었으며, 취소가 확인되면 차액이 종료됩니다. ',
    dataMatchFinish: '데이터 매칭이 완료되었습니다. 데이터에 차이가 없습니다! ',
    diffDataTip: '재고 목록에는 있지만 창고에는 없는 데이터:',
    diffDataTip2: '창고에는 존재하지만 재고 목록에는 존재하지 않는 데이터:',
    onClickDelete: '한번 클릭으로 삭제',
    selectedItems: '{{num}}개의 항목이 선택되었습니다',
    againAddScan: '다시 스캔 추가',
    againDiff: '다시 차이점 생성',
    countingDataIsOverTip: '이 카운트를 종료하시겠습니까?',
    countingInSucc: '재고 계산 성공',
    countingOutSucc: '재고 계산이 성공했습니다',
    delCountingScanBarcode: '현재 재고 스캔에서 이 바코드를 삭제하시겠습니까?',
    barcode: '바코드',
    countingBarcodeInProduct: '재고 목록에서 이 바코드가 속하는 제품',
    storeBarcodeInProduct: '창고에서 이 바코드가 속한 제품',
    optDetail: '세부정보',
    countingDetail: '세부 정보 계산',
    countingProductData: '제품 데이터 계산',
    overCouting: '재고 끝',
    overCoutingTip: '이 재고 계산을 종료하시겠습니까?',
    fillDataDoTip: '차액을 생성하기 전에 제품을 선택하고 바코드 데이터를 입력하세요',
    noDataOverCounting: '현재 인벤토리를 종료할 데이터가 없습니다',
    diffCodes: "차이 바코드",
    normalCodes: "일치 바코드",
    countingCodes: "재고조사",
    confirmDelete: "삭제 확인",
    confirmDeleteContent: "재고 실사 데이터는 삭제 후 복구할 수 없습니다. 삭제하시겠습니까?",
    deleteSuccess: "삭제 성공",
    deleteFailed: "삭제 실패",
    saveFailed: "저장 실패",
    confirmTerminate: "재고 실사 종료 확인",
    confirmTerminateContent: "재고 실사를 종료하면 현재 재고 실사 단이 삭제됩니다. 종료하시겠습니까?",
    terminateSuccess: "재고 실사 단이 삭제되었습니다",
    terminateFailed: "재고 실사 종료 실패",
    addSuccess: "재고 실사 단이 생성되었습니다",
    itemsUpdated: "재고 실사 단이 업데이트되었습니다",
    noCode: "재고 코드가 존재하지 않습니다：{{code}}",
    temp: "임시 저장",
    tempSave: "이 재고조사서를 임시 저장하시겠습니까?",
    tempSaveConfirm: "임시 저장 후 현재 데이터가 저장됩니다.",
    batchImport: "일괄 재고조사 가져오기",
    downloadTemplate: "템플릿 다운로드",
    importData: "재고조사 가져오기",
    invalidTemplate: "올바른 템플릿 파일을 선택해주세요",
    confirmImport: "가져오기 확인",
    productCode: "제품 코드",
    productName: "제품 이름",
    productModal: "규격",
    productUom: "단위",
    bookNum: "장부 수량",
    countedNum: "실사 수량",
    locationIdx: "위치",
    parseDataSuccess: "{{count}}개의 데이터를 성공적으로 구문 분석했습니다",
    parseDataFilter: "{{count}}개의 데이터를 성공적으로 구문 분석했습니다, 비정상 데이터 필터링됨을 확인해 주세요 (행: {{rows}})",
    locationParseFailed: "다음 위치 구문 분석 실패: {{locations}}",
    importSuccess: "재고조사 가져오기 성공",
    countingCompleted: "재고조사 완료",
    confirmCloseImport: "가져오기 닫기 확인",
    confirmCloseImportContent: "닫으면 가져온 데이터가 손실됩니다. 닫으시겠습니까?",
    confirmDeleteRow: "삭제 확인",
    confirmDeleteRowContent: "이 데이터를 삭제하시겠습니까?",
    productCodeNotExisted: "다음 제품 코드가 존재하지 않습니다: \"{{codes}}\"",
    countingHistory: "재고조사 기록",
    countingHistoryAll: "재고조사 기록_전체",
    inventoryImportTemplate: "재고조사 가져오기 템플릿",
    inputTemp: "템플릿에서 입력",
    noLot: "로트 생성 안 함 (재고조사 후 생성되는 입출주문은 로트 생성 안 함)",
    initLoc: "로케이션 데이터 준비 중",
    subErr: "lot, 재고 코드, 수량을 입력하세요",
    countErr: "실사 실패",
    countErrTip: "빨간색으로 표시된 행의 실사가 실패했습니다",
    countErrTip1: "주문 번호가 있으면 실사 주문이 생성되었지만 실사가 실패한 것이고, 없으면 실사 주문이 생성되지 않은 것입니다",
    countNo: "실사 주문 번호",
    countErrTip2: "Excel 파일의 다음 데이터 행에 이상이 있습니다",
    countErrTip3: "Excel 파일의 다음 행에서 재고 코드, 초기 실사 수량, 로케이션이 올바르게 입력되었는지 확인하세요",
    countErrTip4: "다음 품번이 존재하지 않습니다",
    countErrTip5: "분석 실패",
    countErrTip6: "데이터 분석 실패. 표 데이터를 확인한 후 나중에 다시 시도하세요",
    countErrTip7: "{{index}}행",
};

export default ko;